import { FC } from "react";
import { Box, Button, makeStyles } from "@material-ui/core";

interface TabSwitchType {
  activeTab: string;
  tabList: { id: string; name: string }[];
  action: (arg: string) => void;
  isSmallSize?: boolean;
}

interface FilterSwitchType {
  type: string | undefined;
  enabledFilters: string[];
  action: (select: string) => void;
  isSmallSize?: boolean;
}

export const TabSwitch: FC<TabSwitchType> = ({ activeTab, tabList, action, isSmallSize }) => {
  const classes = useStyles();

  return (
    <Box className={classes.root}>
      {tabList.map((item, index) => (
        <Button
          key={item.id}
          variant={"outlined"}
          name={item.id}
          className={`${classes.filterBtn} ${returnBorderRadiusStyle(classes, index, tabList)} ${activeTab === item.id && classes.activeBtn} ${isSmallSize && classes.isSmallSize}`}
          onClick={() => action(item.id)}
        >
          {item.name}
        </Button>
      ))}
    </Box>
  );
};

export const FilterSwitch: FC<FilterSwitchType> = ({
  type,
  enabledFilters,
  action,
  isSmallSize,
}) => {
  const classes = useStyles();

  const filters = [
    { id: "date", name: "Daily" },
    { id: "week", name: "Weekly" },
    { id: "week_range", name: "Week Range" },
    { id: "month", name: "Monthly" },
    { id: "year", name: "Yearly" },
  ].filter((item) => enabledFilters.includes(item.id));

  return (
    <Box className={classes.root}>
      {filters.map((item, index) => (
        <Button
          key={item.id}
          variant={"outlined"}
          name={item.id}
          className={`${classes.filterBtn} ${returnBorderRadiusStyle(classes, index, filters)} ${isSmallSize && classes.isSmallSize} ${type === item.id ? classes.activeBtn : ""}`}
          onClick={() => action(item.id)}
        >
          {item.name}
        </Button>
      ))}
    </Box>
  );
};

const returnBorderRadiusStyle = (
  classes: any,
  index: number,
  filters: {
    id: string;
    name: string;
  }[],
) => {
  switch (filters.length) {
    case 1:
      return classes.midBtn;
    case 2:
      return index === 0 ? classes.leftBtn : classes.rightBtn;
    default:
      return index === 0
        ? classes.leftBtn
        : index === filters.length - 1
          ? classes.rightBtn
          : classes.midBtn;
  }
};

const useStyles = makeStyles((theme) => ({
  root: {},
  filterBtn: {
    borderColor: "#828487",
    height: "100%",
    fontSize: 16,
    textWrap: "nowrap",
  },
  leftBtn: {
    boxSizing: "border-box",
    borderRadius: "4px 0 0 4px",
  },
  midBtn: {
    boxSizing: "border-box",
    borderRadius: "0",
    borderLeft: "none",
  },
  rightBtn: {
    boxSizing: "border-box",
    borderRadius: "0 4px 4px 0",
    borderLeft: "none",
  },
  activeBtn: {
    background: "#EAECEC",
  },
  isSmallSize: {
    fontSize: 14,
    padding: "6px 12px",
  },
  "@media (max-width: 840px)": {
    root: {
      width: "100%",
      display: "flex",
    },
    filterBtn: {
      flex: 1,
    },
  },
}));
